import React from 'react'
import cn from 'classnames'
import ActivityRepeatAbout from './ActivityRepeatAbout'
import ActivityRepeatButton from './ActivityRepeatButton'
import { withTranslation } from 'react-i18next'

import './styles.scss'

const baseClass = 'activity-repeat'

const ActivityRepeat = ({ i18n: { language } }) => (
  <div
    className={cn(`${baseClass}`, {
      [`${baseClass}__${language}`]: language,
    })}
  >
    <ActivityRepeatButton />
    <ActivityRepeatAbout />
  </div>
)

export default withTranslation()(ActivityRepeat)
